import React from 'react'
import { Tab as MuiTab } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(
  ({ palette, typography, customShadows, spacing, breakpoints }) => ({
    root: {
      textTransform: 'none',
      ...typography.body1,
      color: palette.grey.shade[80],
      fontWeight: 500,
      opacity: 1,
      '& .MuiTab-selected': {
        backgroundColor: palette.white.off
      },
      '&.MuiTab-labelIcon .MuiTab-wrapper > *:first-child': {
        margin: 0,
        marginRight: spacing(1)
      },
      [breakpoints.down('sm')]: { flexGrow: 1 }
    },
    wrapper: {
      flexDirection: 'row',
      alignItems: 'center'
    },
    selected: {
      backgroundColor: palette.white.off
    }
  })
)

const Tab = props => {
  const classes = useStyles(props)
  return <MuiTab classes={classes} {...props} />
}

export default Tab
